
import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ------------------------Get Content Detail------------------
export const getContentApi = async (data) => {
  const endPoint =
    `cms` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
//   Update Content Detail
export const updateContentApi = async (data) => {
  const endPoint = `cms/update`;
  return await axios.post(endPoint, data, setJwtToken());
};